import { IGetProductTypeModel } from "../models/GetProductType.Model";
import { isTokenExpired } from "../helpers/TokenHelper";
import createHttpInstance from "./http-common";

class ProductTypeServices {
    private serviceName = '/ProductType';

    async getProductTypeById(Id: number) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`${this.serviceName}/getProductTypebyId/${Id}`).catch((err: Error) => {
            throw err?.message;
        })
    }

    async getAllProducts(data: IGetProductTypeModel) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/GetProductTypeList`, data).catch((err: Error) => {
            throw err?.message;
        })
    }
    
    async UpdateModelVarients(data: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/UpdateModelVarients`, data).catch((err: Error) => {
            throw err?.message;
        });
    }

    async GetList() {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`${this.serviceName}/GetList`).catch((err: Error) => {
            throw err?.message;
        });
    }
}

export default new ProductTypeServices();